import React from "react";
import { IconButton } from "@mui/material";
import { InfoOutlined, ModeEditOutlineTwoTone } from "@mui/icons-material";
import { Link } from "react-router-dom";

import AppTable from "components/Shared/AppTable";
import { useVehicleDetailContext } from "contexts/VehicleDetailContext";
import { useListVehicleFuelByVehicleIdQuery } from "store/services/vehicleFuelApi";
import { useTablePagination } from "hooks";
import { localizeDateShort } from "utils/dateFormats";

const VehicleFuelListByVehicle = () => {
  const { vehicleDetail } = useVehicleDetailContext();

  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();

  const columns = [
    {
      name: "Fuel ID",
      selector: (row) => row?.fuelId,
      cell: (row) => row?.fuelId || "N/A",
    },
    {
      name: "Fuel Type",
      selector: (row) => row?.fuel?.[0]?.fuelType,
      cell: (row) => row?.fuel?.[0]?.fuelType || "N/A",
    },
    {
      name: "Distance",
      selector: (row) => row?.distance,
      cell: (row) => row?.distance || "N/A",
    },
    {
      name: "Total Cost",
      selector: (row) =>
        row?.fuel?.reduce((sum, f) => sum + (f.totalCost || 0), 0),
      cell: (row) =>
        row?.fuel?.length
          ? `Rs. ${row.fuel
              .reduce((sum, f) => sum + (f.totalCost || 0), 0)
              .toFixed(2)}`
          : "N/A",
    },
    {
      name: "Date",
      selector: (row) => localizeDateShort(row?.createdAt),
      cell: (row) => localizeDateShort(row?.createdAt) || "N/A",
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/app/crm/vehicle-fuel/${row?._id}/detail`}>
            <IconButton
              size="small"
              aria-label="View Fuel Record"
              color="primary"
            >
              <InfoOutlined />
            </IconButton>
          </Link>
          <Link to={`/app/crm/vehicle-fuel/${row?._id}/edit`}>
            <IconButton size="small" aria-label="Edit Fuel Record">
              <ModeEditOutlineTwoTone />
            </IconButton>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  // RTK Query
  const {
    data: vehicleFuelRs,
    isLoading,
    isFetching,
  } = useListVehicleFuelByVehicleIdQuery({
    vehicleId: vehicleDetail?._id,
    page: currentPage,
    limit: perPage,
  });

  return (
    <div>
      <AppTable
        columns={columns}
        data={vehicleFuelRs?.data ?? []}
        progressPending={isLoading || isFetching}
        paginationServer
        paginationPerPage={perPage}
        paginationTotalRows={vehicleFuelRs?.totalItems ?? 0}
        paginationDefaultPage={currentPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />
    </div>
  );
};

export default VehicleFuelListByVehicle;
